import { makeAutoObservable } from "mobx"

class AppStore {
  windowHeight = window.innerHeight
  windowWidth = window.innerWidth
  device = 0
  ip = ""
  frame_footer = false
  isLocalHost = false
  constructor() {
    makeAutoObservable(this)
  }

  setWindowHeight = (data) => (this.windowHeight = data)
  setWindowWidth = (data) => (this.windowWidth = data)
  setDevice = (data) => (this.device = data)
  setLocalHost = (data) => (this.isLocalHost = data)
  setFrameFooter = (data) => (this.frame_footer = data)
  setIpAddress = (data) => (this.ip = data)
}

export default new AppStore()
